import styled from 'styled-components';

import { LoaderSpinner } from '@dreryk/react-components';

const StyledSidePanelLoaderContainer = styled.div`
   position: absolute;
   left: 50%;
   top: 50%;
   transform: translate(-50%, -50%);
`;

StyledSidePanelLoaderContainer.displayName = 'StyledSidePanelLoaderContainer';

export const SidePanelLoader = (): JSX.Element => {
   return (
      <StyledSidePanelLoaderContainer>
         <LoaderSpinner />
      </StyledSidePanelLoaderContainer>
   );
};
